<template>
  <div class="box-second">
    <p class="title-crumb">
      <el-breadcrumb separator-class="el-icon-arrow-right color3">
        <el-breadcrumb-item>混凝土监测</el-breadcrumb-item>
      </el-breadcrumb>
    </p>
    <div class="main">
      <div class="build-bar">
        <p style="border-left: 5px solid #018eed; padding-left: 1vh">
          大体积混凝土结构测温记录
        </p>
        <el-button type="primary" @click="addMac">设备添加</el-button>
      </div>
      <div class="main-table">
        <div style="height:100%;overflow: auto;">
          <div class="secend_content" v-for="(item,index) in tableDataEnd"  :key="index">
            <div class="entRisk_content" >
              <div class="th_one">
                <div>设备编号：{{item.mixCoding}}</div>
                <div>设备名称：{{item.partName}}</div>
                <div>监测位置：</div>
              </div>
              <div>
                联网状态:
                <span style="color: #36c635" v-if="item.online=='在线'">{{item.online}}</span>
                <span style="color: #f00" v-else-if="item.online=='离线'">{{item.online}}</span>
                <span  v-else>{{item.online}}</span>
              </div>
              <div>砼浇灌日期：{{item.wateringDate}}</div>
              <div style="position: relative;padding:20px 0 0;">
                  <img class="blue" style="width:120px;height:120px;" src="../../../assets/image/white.png" alt />
                  <img  class="round" :class="item.online=='在线'?'round_normal':''" style="width:120px;height:120px;top: 20px;" src="../../../assets/image/round.png" alt />
                  <div style="position: absolute; top: 55px; left: 22px; color: #6b6b6b; " >
                    <div v-if="item.statueName=='正常'">监测正常</div>
                    <div v-else-if="item.statueName=='预警'" style="color:#E6A23C;">监测预警</div>
                    <div>24小时</div>
                  </div>
              </div>
              <div>
                <el-button type="primary" @click.stop="handSet(index,item)"
                >预警设置</el-button>
                <el-button type="danger"@click.stop="reset(item.id)"   plain>重置初始值</el-button>
                <el-button type="success" @click="toInfo(item)"
                >查看</el-button>
                <el-button type="warning" @click.stop="handleEdit(index,item)"
                  >编辑</el-button
                >
                <!-- <el-button type="danger"  @click.stop="handeldelete(item.id)"
                  >删除</el-button
                > -->
                <el-button type="info"  @click.stop="macDelete(index,item)"
                  >解绑</el-button
                >
              </div>
            </div>
            <div style="padding:1vh 1vw;text-align: right;"><el-button type="primary" @click="addTemper">添加温度测点</el-button></div>
            <el-table :data="item.tsDtuSensorList" height="100%" style="width: 100%" :header-cell-style="{background:'#F5F7F9',color:'#909399'}">
                <el-table-column label="序号" type="index" width="100"></el-table-column>
                <el-table-column label="监测类型">
                    <template slot-scope="scope">
                        <span>{{ scope.row.name }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="监测位置">
                    <template slot-scope="scope">
                        <span>{{ scope.row.tsSersorTypeName }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="设备号">
                    <template slot-scope="scope">
                        <span>{{ scope.row.tsSersorImei }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="状态">
                    <template slot-scope="scope">
                      <span v-if="scope.row.online=='在线'" style="color:#67C23A;">{{scope.row.online}}</span>
                      <span v-else-if="scope.row.online=='离线'" style="color:#F56C6C;">{{scope.row.online}}</span>
                      <span v-else-if="scope.row.online=='失效'" style="color:#909399;">{{scope.row.online}}</span>
                      <span v-else-if="scope.row.online=='未连接'" style="color:#E6A23C;">{{scope.row.online}}</span>
                      <span v-else style="color:#909399;">{{scope.row.online}}</span>
                        <!-- <span v-if="scope.row.status=='0'" style="color:#67C23A;">正常</span>
                        <span v-else-if="scope.row.status=='-1'" style="color:#F56C6C;">异常</span>
                        <span v-else></span> -->
                    </template>
                </el-table-column>
                <el-table-column label="数据监测">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status==0" style="color:#67C23A;">{{ scope.row.nowValue }}</span>
                        <span v-else-if="scope.row.status==-1" style="color:#F56C6C;">{{ scope.row.nowValue }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="400">
                    <template slot-scope="scope">
                      <el-button size="mini" @click="handleEditEq(scope.$index, scope.row)" >编辑</el-button>
                      <el-button size="mini" type="danger" @click="handleDeleteEq(scope.$index, scope.row)">删除</el-button>
                    </template>
                </el-table-column>
              </el-table>
          </div>
        </div>
        <!-- <el-table
          :data="tableDataEnd"
          height="100%"
          style="width: 100%"
          :header-cell-style="{ background: '#F5F7F9', color: '#909399' }"
        >
          <template slot= `"empty">
            <p>{{ dataText }}</p>
          </template>
          <el-table-column
            label="序号"
            type="index"
            width="100"
          ></el-table-column>
          <el-table-column label="编号">
            <template slot-scope="scope">
              <span class="color5" @click="toInfo(scope.row)">{{
                scope.row.mixCoding
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="结构部位">
            <template slot-scope="scope">
              <span>{{ scope.row.partName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="砼浇灌日期">
            <template slot-scope="scope">
              <span>{{ scope.row.wateringDate }}</span>
            </template>
          </el-table-column>
          <el-table-column label="砼数量（m³）">
            <template slot-scope="scope">
              <span>{{ scope.row.concreteNum }}</span>
            </template>
          </el-table-column>
          <el-table-column label="砼强度等级">
            <template slot-scope="scope">
              <span>{{ scope.row.strengthGrade }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="300">
            <template slot-scope="scope">
              <el-button
                type="primary"
                @click="handSet(scope.$index, scope.row)"
                >预警设置</el-button
              >
              <el-button
                size="mini"
                v-if="isMenuExit('pro:elebox:edit')"
                @click="handleEdit(scope.$index, scope.row)"
                >编辑</el-button
              >
              <el-button
                size="mini"
                v-if="isMenuExit('pro:elebox:edit')"
                @click="macDelete(scope.$index, scope.row)"
                >解绑</el-button
              >
            </template>
          </el-table-column>
        </el-table> -->
        <!-- 表单列表 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 20, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalItems"
        ></el-pagination>
      </div>
    </div>
    <!-- 新增大体积混凝土结构 -->
    <el-dialog width="30%" title="添加混凝土结构" :visible.sync="mixVisible">
      <el-form
        :model="addForm"
        ref="addForm"
        label-width="150px"
        :label-position="labelPosition"
        class="add-form"
        width="30%"
        :rules="rules"
      >
        <el-form-item label="结构部位名称：" prop="partName">
          <el-input
            v-model="addForm.partName"
            placeholder="请输入结构部位名称"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="砼强度等级：" prop="strengthGrade">
          <el-input
            v-model="addForm.strengthGrade"
            placeholder="请输入序列号"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="配合比编码：">
          <el-input
            v-model="addForm.mixCoding"
            placeholder="请输入配合比编码"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="砼数量：" prop="concreteNum">
          <el-input
            v-model="addForm.concreteNum"
            placeholder="请输入砼数量"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="浇灌时间："
          prop="wateringDate"
          style="text-align: left"
        >
          <el-date-picker
            v-model="addForm.wateringDate"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="浇灌温度：">
          <el-input
            v-model="addForm.wateringTemperature"
            placeholder="请输入浇灌温度"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="开始养护温度：">
          <el-input
            v-model="addForm.maintenTemperature"
            placeholder="请输入开始养护温度"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="DTU设备：">
          <el-select v-model="addForm.tsDtuId" clearable placeholder="请选择">
            <el-option
              v-for="item in TsDtuList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="mixVisible = false">取 消</el-button>
        <el-button type="primary" @click="sumbitAddRow('addForm')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 预警弹框 -->
    <el-dialog
      :title="dialogSetTitle"
      :visible.sync="setVisible"
      center
      :append-to-body="true"
      :lock-scroll="false"
      class="add-form"
      width="30%"
    >
      <el-form
        :model="setForm"
        ref="setForm"
        label-width="150px"
        :label-position="labelPosition"
      >
        <div v-for="(item, index) in type" :key="index">
          <el-form-item :label="item.name">
            <el-input-number
              v-model="item.num"
              :step="1"
              label="描述文字"
            ></el-input-number>
            <span> 度</span>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="setVisible = false">取 消</el-button>
        <el-button type="primary" @click="sumbitSetRow('setForm')">确 定</el-button>
        <el-button type="info" @click="setDetfaule">恢复默认值</el-button>
      </div>
    </el-dialog>
    <!-- 添加温度测点 -->
    <el-dialog
      title="添加温度测点"
      :visible.sync="temperVis"
      center
      :append-to-body="true"
      :lock-scroll="false"
      width="30%"
      style="height: 100%"
    >
      <el-form
        :model="creatForm"
        ref="creatForm"
        label-width="200px"
        :label-position="labelPosition"
      >
        <el-form-item label="名称">
          <el-input
            style="width: 217px"
            v-model="creatForm.name"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="传感器设备号">
          <el-input
            style="width: 217px"
            v-model="creatForm.tsSersorImei"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="监测类型:">
          <el-select
            v-model="creatForm.tsSersorType"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in types"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="temperVis = false">取 消</el-button>
        <el-button type="primary" @click="sumbitEquip('creatForm')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import myHttp from '../../../untils/port'
import util from '../../../untils/util'
import base from '../../../untils/base'
export default {
  data() {
    return {
      tableSn: '',
      tableDataEnd: [],
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      groupId: '',
      dataText: '数据加载中...',
      addVis: false,
      dialogTitle: '',
      labelPosition: 'right',
      addForm: {
        id: '',
        projectId: '',
        partName: '',
        strengthGrade: '',
        mixCoding: '',
        concreteNum: '',
        wateringDate: '',
        wateringTemperature: '',
        maintenTemperature: '',
        createBy: '',
        tsDtuId: '',
      },
      dialogSetTitle: '设置预警参数',
      setVisible: false,
      rules: {
        partName: [
          { required: true, message: '请输入结构部位名称', trigger: 'blur' },
        ],
        strengthGrade: [
          { required: true, message: '请输入砼强度等级', trigger: 'blur' },
        ],
        concreteNum: [
          { required: true, message: '请输入砼数量', trigger: 'blur' },
        ],
        wateringDate: [
          { required: true, message: '请选择浇灌时间', trigger: 'blur' },
        ],
      },
      diaText: '数据加载中...', //
      macList: [], //弹出框table列表
      innerVisible: false,
      mixVisible: false, //大体积混凝土结构- 弹出框
      macForm: {
        name: '',
      },
      concreteProjectId: '', //当前混凝土数据id
      concreteList: [], //混凝土设备列表
      TsDtuList: [], //设备列表
      setForm: {},
      id: '',
      tsDtuId: '',
      type: [
        { name: '上', tsSersorType: '1', num: '0' },
        { name: '中', tsSersorType: '2', num: '0' },
        { name: '下', tsSersorType: '3', num: '0' },
      ],

      //温度测点
      creatForm: {
        name: '',
        tsDtuId: '',
        useId: '',
        tsSersorImei: '',
        createBy: '',
        tsSersorType: '',
        usedFor: '',
      },
      temperVis: false, //添加温度测点弹出框
      types: [], //监测类型列表
    }
  },
  mounted() {
    this.groupId = util.session.get('groupId')
    this.addForm.projectId = this.groupId
    this.getData()
    this.getMachine()
  },
  methods: {
    getData() {
      var that = this
      myHttp
        .selectConcreteProjectListPage({
          projectId: this.groupId,
          pageNum: this.currentPage,
          pageSize: this.pageSize,
        })
        .then(function (resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.PageInfo.list || []
            for (var i = 0; i < list.length; i++) {
              list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
              list[i].statueName = '正常'
              for(var j=0;j<list[i].tsDtuSensorList.length;j++){
                list[i].tsDtuSensorList[j].status = that.getStatus(list[i].warning,list[i].tsDtuSensorList[j].tsSersorType,list[i].tsDtuSensorList[j].nowValue)
                if(list[i].tsDtuSensorList[j].status=='-1'){
                  list[i].statueName = '预警'
                }
              }
            }
            that.tableDataEnd = list
            that.totalItems = resp.data.data.PageInfo.total
            if (that.tableDataEnd.length == 0) {
              that.dataText = '暂无数据'
            }
          } else {
            that.dataText = '暂无数据'
          }
        })
    },

    //根据type获取状态
    getStatus(warn,type,val){
      var list = warn && warn!=''?JSON.parse(warn):[]
      val = val && val!=''?val:0
      var result = '0'
      for(var i=0;i<list.length;i++){
        if(list[i].tsSersorType==type){
          if(parseFloat(list[i].num)==0 || parseFloat(list[i].num)>=parseFloat(val)){
            result = '0'  //正常
          }else{
            result = '-1'  //异常
          }
        }
      }
      return result
    },


    // 设备列表
    getMachine() {
      var that = this
      myHttp
        .selectTsDtuByList({
          groupId: this.groupId,
          userType: util.session.get('roleId'),
          useType:'1'
        })
        .then(
          function (resp) {
            if (resp.data.code == '200') {
              that.TsDtuList = resp.data.data.TsDtu || []
            } else {
              that.$message.error(resp.data.msg)
            }
          },
          function () {}
        )
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.currentPage = val
      this.getData()
    },
    // 监控当前页码
    currentChangePage() {
      this.getData()
    },
    //查询
    doFilter() {
      this.currentPage = 1
      this.getData()
    },

    //添加
    addMac() {
      this.mixVisible = true
      this.addForm.id = ''
      this.addForm.partName = ''
      this.addForm.strengthGrade = ''
      this.addForm.mixCoding = ''
      this.addForm.concreteNum = ''
      this.dialogTitle = '添加'
      this.addForm.wateringDate = util.myTime.getCurTime() + ' 00:00:00'
      this.addForm.wateringTemperature = ''
      this.addForm.maintenTemperature = ''
      this.addForm.tsDtuId = ''
    },
    //编辑
    handleEdit(index, row) {
      this.mixVisible = true
      this.addForm.id = row.id
      this.addForm.partName = row.partName
      this.addForm.strengthGrade = row.strengthGrade
      this.addForm.mixCoding = row.mixCoding
      this.addForm.concreteNum = row.concreteNum
      this.addForm.wateringDate = row.wateringDate
      this.addForm.wateringTemperature = row.wateringTemperature
      this.addForm.tsDtuId = row.tsDtuId
      this.addForm.maintenTemperature = row.maintenTemperature
      this.dialogTitle = '修改'
    },
    //删除
    // handleDelete(index,row){
    //     var that = this
    //     this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
    //         confirmButtonText: '确定',
    //         cancelButtonText: '取消',
    //         type: 'warning'
    //     }).then(() => {
    //         myHttp.delDistribution({
    //             id: row.id,
    //             updateBy:util.session.get('user').id
    //         }).then(function(resp) {
    //             if (resp.data.code == '200') {
    //                 that.$message.success('删除成功')
    //                 that.getData()
    //             } else {
    //                 that.$message.error(resp.data.msg)
    //             }
    //         })
    //     })
    // },
    //提交
    sumbitAddRow(formName) {
      var that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (that.addForm.id == '') {
            that.addForm.createBy = util.session.get('user').id
            myHttp.postConcreteProject(that.addForm).then(
              function (resp) {
                if (resp.data.code == '200') {
                  that.$message.success('添加成功')
                  that.mixVisible = false
                  that.currentPage = 1
                  that.getData()
                } else {
                  that.$message.error(resp.data.msg)
                }
              },
              function () {}
            )
          } else {
            that.addForm.updateBy = util.session.get('user').id
            myHttp.updateConcreteProject(that.addForm).then(
              function (resp) {
                if (resp.data.code == '200') {
                  that.$message.success('修改成功')
                  that.mixVisible = false
                  that.getData()
                } else {
                  that.$message.error(resp.data.msg)
                }
              },
              function () {}
            )
          }
        }
      })
    },

    //展示二维码
    erCode(index, row) {
      this.codeVis = true
      this.codeUrl = '/pages/equipCheck/equipCheck?snId=' + row.sn
      this.codeTit = row.location
    },

    /**
     * 判断是否展示
     */
    isMenuExit(row) {
      // var flag = util.common.filterBtnMenu(row)
      // return flag
      return true
    },
    toInfo(row) {
      this.$router.push({ path: '/mixedInfo/' + row.id })
    },
    /**
     * 绑定设备
     */
    macListAdd(index, row) {
      var that = this
      this.addVis = true
      this.concreteProjectId = row.id
      this.macForm.name = row.partName
      myHttp
        .selectConcreteListByProjectId2({
          projectId: this.groupId,
          concreteProjectId: row.id,
        })
        .then(function (resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.Concrete || []
            that.macList = list
            if (list.length == 0) {
              that.diaText = '暂无数据'
            }
          } else {
            that.diaText = '暂无数据'
          }
        })
    },
    /**
     * 刷新绑定设备
     */
    refreshMac(id) {
      var that = this
      myHttp
        .selectConcreteListByProjectId2({
          projectId: this.groupId,
          concreteProjectId: id,
        })
        .then(function (resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.Concrete || []
            that.macList = list
            if (list.length == 0) {
              that.diaText = '暂无数据'
            }
          } else {
            that.diaText = '暂无数据'
          }
        })
    },
    /**
     * 设备添加
     */
    addDialogMac() {
      this.innerVisible = true
      var that = this
      myHttp
        .selectConcreteListByProjectId({
          projectId: this.groupId,
        })
        .then(function (resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.Concrete || []
            that.concreteList = list
          }
        })
    },
    /**
     * 提交绑定设备
     */
    addMacFun() {
      var that = this
      myHttp
        .bindingEquipConcrete({
          concreteProjectId: this.concreteProjectId,
          id: this.macForm.concreteId,
        })
        .then(function (resp) {
          if (resp.data.code == '200') {
            that.$message.success('添加成功')
            that.innerVisible = false
            that.refreshMac(that.concreteProjectId)
          } else {
            that.$message.error(resp.data.msg)
          }
        })
    },
    /**
     * 解除设备
     */
    macDelete(index, row) {
      var that = this
      if (!row.tsDtuSensorId) {
        that.$message.success('该设备已解绑')
        return
      }
      this.$confirm('此操作将解除设备, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        myHttp
          .unbundlingTsDtuSensorDTU({
            id: row.tsDtuSensorId,
            updateBy: util.session.get('user').id,
          })
          .then(function (resp) {
            if (resp.data.code == '200') {
              that.$message.success('删除成功')
              that.refreshMac(that.concreteProjectId)
            } else {
              that.$message.error(resp.data.msg)
            }
          })
      })
    },
    handSet(index, row) {
      console.log(index)
      this.setVisible = true
      this.id = row.tsDtuSensorId
      this.tsDtuId = row.id
      this.bundlingTsDtuSensorDTU(index)
    },
    // 预警值回显
    bundlingTsDtuSensorDTU(index) {
      var that = this
      console.log(this.tsDtuId)
      // myHttp
      //   .bundlingTsDtuSensorDTU({
      //     useId: this.tsDtuId,
      //   })
      //   .then(function (resp) {
      //     // console.log(resp)
      //     if (resp.data.code == '200') {
            console.log(this.tableDataEnd[index].warning)
            var data =this.tableDataEnd[index].warning
            if (data != 'null' && data != null ) {
              that.type = JSON.parse(data)
            }
      //     }
      //   })

    },
    // 设置预警值
    sumbitSetRow(formName) {
      var that = this
      // console.log(that.addForm)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.id == '') {
            that.$message.error('请先绑定设备')
            return
          }
          let setFormarry = that.type
          setFormarry = JSON.stringify(setFormarry)
          myHttp
            .warningDTU({
              id: this.id,
              jsonString: setFormarry,
            })
            .then(
              function (resp) {
                if (resp.data.code == '200') {
                  that.$message.success('设置成功')
                  that.setVisible = false
                  that.currentPage = 1
                  that.getData()
                } else {
                  that.$message.error(resp.data.msg)
                }
              },
              function () {}
            )
          // }
        }
      })
    },

    //设置默认值
    setDetfaule(){
      this.type[0].num = 150
      this.type[1].num = 150
      this.type[2].num = 150
    },

    //字典表（检测类型）
    getDict() {
      var that = this
      myHttp
        .getDictByType({
          type: 'concrete_type',
        })
        .then(function (resp) {
          if (resp.data.code == '200') {
            that.types = resp.data.data.dictList
          } else {
            that.$message.error(resp.data.msg)
          }
        })
    },
    /**
     * 添加观测点
     */
    addTemper() {
      this.getDict()
      var that = this
      this.temperVis = true
      this.creatForm.id=''
      this.creatForm.tsSersorImei = ''
      this.creatForm.useId = this.id
      this.creatForm.name = ''
      this.creatForm.tsSersorType = ''
      this.creatForm.createBy = util.session.get('user').id
      this.creatForm.usedFor = 1
    },
    /**
     * 提交观测点
     */
    sumbitEquip(formName) {
      var that = this
      console.log(this.creatForm.id)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(this.creatForm.id==''){
               myHttp.postTsDtuSensorCGQ(that.creatForm).then(
            function (resp) {
              if (resp.data.code == '200') {
                that.$message.success('添加成功')
                that.temperVis = false
                that.getData()
              } else {
                that.$message.error(resp.data.msg)
              }
            },
            function () {}
          )
          }else{
            that.creatForm.updateBy = util.session.get('user').id
             myHttp.updateTsDtuSensorCGQ(that.creatForm).then(
            function (resp) {
              if (resp.data.code == '200') {
                that.$message.success('修改成功')
                that.temperVis = false
                that.getData()
              } else {
                that.$message.error(resp.data.msg)
              }
            },
            function () {}
          )
          }
        }
      })
    },

      //编辑
    handleEditEq(index, row) {
        this.getDict()
        this.temperVis=true
        this.creatForm.tsSersorImei = row.tsSersorImei
      // this.creatForm.tsDtuId = ''
        this.creatForm.useId = this.id
        this.creatForm.name = row.name
        this.creatForm.id = row.id
        this.creatForm.tsSersorType = row.tsSersorType
        this.creatForm.createBy = util.session.get('user').id
        this.creatForm.usedFor = 1
    },
    //删除
    handleDeleteEq(index,row){
        var that = this
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            myHttp.deleteTsDtuSensorCGQ({
                id: row.tsDtuSensorId,
                updateBy:util.session.get('user').id
            }).then(function(resp) {
                if (resp.data.code == '200') {
                    that.$message.success('删除成功')
                    that.getData()
                } else {
                    that.$message.error(resp.data.msg)
                }
            })
        })
    },
     // reset 重置初始值
   reset(id){

// resetValue
var that = this
myHttp
  .resetValue({
    useId:id
  })
  .then(
    function (resp) {
      if (resp.data.code == '200') {
        that.$message.success(resp.data.msg)
      } else {
        that.$message.error(resp.data.msg)
      }
    },
    function () {}
  )
},
  },
}
</script>

<style scoped>
.main {
  flex-wrap: wrap;
  align-content: flex-start;
}
.main-table {
  width: 100%;
  height: calc(100% - 11.4vh);
}
.build-bar {
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 6vh;
  border-bottom: 3px solid #17b2fe;
  background: #fff;
  justify-content: space-between;
  padding: 0 1vw;
}

.build-bar span {
  margin-left: 30px;
  white-space: nowrap;
  display: inline-block;
}

.build-bar > .el-input {
  width: 200px;
  font-size: 12px;
}
.build-bar > .el-button {
  margin-left: 30px;
  /* background-color: #17b2fe;
        border-color: #17b2fe; */
}
.erCode {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  justify-items: center;
  align-content: center;
  align-items: center;
  flex-wrap: wrap;
}
.avatar {
  width: 100%;
}
.dialog-footer{
  text-align: center;
}
.content >>> .el-card__body {
  padding: 0 !important;
  height: 100% !important;
}
.grid-content {
  height: 2.5vh;
  font-size: 1.6vh;
}
.aside {
  box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
  border-radius: 10px !important;
  border: 0px !important;
  background-color: rgb(255, 255, 255);
  display: flex;
  flex-direction: column;
}
.search-section {
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin: 20px 35px 20px -12px;
  height: 40px;
  justify-content: space-between;
}
.secend_content {
  height: 100%;
  /* margin-top: 30px; */
  /* margin-bottom: 30px; */
  background: #f5f5f5;
  /* padding: 0 50px; */
  overflow: hidden;
}
.entRisk_content {
  width: 95%;
  /* height: ; */
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 5px solid #f5f5f5;
  cursor: pointer;
}
.entRisk_bot {
  width: 95%;
  background: #011c56;
}
.left_head {
  /* width: 20%; */
  display: flex;
  color: #fff;
}
.th_one {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 30%;
  text-align: left;
}
.spealic {
  background: #fff;
  padding: 0 36px;
  display: flex;
  width: 98%;
  margin: 0 auto;
  /* padding-bottom: 30px; */
  height: 60px;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  margin-top: 10px;
}
.round {
  display: block;
  position: absolute;
  display: block;
    top: 0;
}
.round_normal {
  animation: rotate 6s linear infinite;
}
@keyframes rotate {
  0% {
    transform: rotateZ(0deg); /*从0度开始*/
  }
  100% {
    transform: rotateZ(360deg); /*360度结束*/
  }
}
.text {
  text-align: left;
}
.hand {
  cursor: pointer;
}
.hand:hover {
  color: #0085ff;
}
.imgs {
  width: 100%;
  display: table-cell;
  vertical-align: middle;
  text-align: center;
  border: 1px solid #000;
}
.imgs > img {
  width: 200px;
  /* height: 200px; */
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.imgs > div {
  width: 200px;
  /* height: 200px; */
  position: absolute;
  top: 60%;
  left: 50%;
  transform: translate(-60%, -50%);
  font-weight: bolder;
  color: #6b6b6b;
}
.add {
  padding: 10px 20px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  cursor: pointer;
}
</style>

<style>
@import '../../../assets/css/common.css';
</style>